import React, { useState } from 'react';

import {
  FormControl,
  FormLabel,
  RadioGroup as MuiRadioGroup,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import weakKey from 'weak-key';

import { List } from '../../../atoms';
import { ListItem } from '../../../atoms/List';
import { RadioButton } from '../../../atoms/RadioButton';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    paddingLeft: theme.spacing(2.5),
    '& .MuiListItemText-primary': {
      display: 'inline-flex',
      alignItems: 'center',
    },
    '& .MuiListItem-root': {
      paddingTop: theme.spacing(1.8),
      paddingBottom: theme.spacing(1.8),
    },
    '& .MuiIconButton-root': {
      marginRight: theme.spacing(2),
    },
    '& .MuiSvgIcon-root:not(.MuiRadio-root .MuiSvgIcon-root)': {
      marginRight: theme.spacing(2),
    },
    '& .MuiFormControlLabel-label': {
      display: 'inline-flex',
    },
  },
  radioGroup: {
    '& [class*="MuiFormControlLabel-root"]': {
      margin: 0,
    },
  },
}));

export type RadioItem = {
  checked?: boolean;
  disabled?: boolean;
  key?: string;
  label: React.ReactNode;
  testId?: string;
  value?: string | number;
};

export interface RadioGroupListProps {
  groupLabel?: string;
  name?: string;
  onChange: (element: any) => void;
  options: RadioItem[];
  value: string | number;
}

export const RadioGroupList = (props: RadioGroupListProps): JSX.Element => {
  const { groupLabel, options, onChange, value: defaultValue, name } = props;
  const [value, setValue] = useState(defaultValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
    onChange && onChange(event);
  };

  const optionsMapped: ListItem[] = options.map((option) => {
    const { label, testId, checked, disabled, value: optionValue } = option;
    return {
      primaryContent: (
        <RadioButton
          checked={checked || optionValue === value}
          disabled={disabled}
          key={weakKey(option)}
          label={label}
          testId={testId}
          value={optionValue}
        />
      ),
      status: checked ? 'checked' : 'default',
    };
  });

  const classes = useStyles();

  return (
    <FormControl className={classes.root}>
      {groupLabel && <FormLabel>{groupLabel}</FormLabel>}
      <MuiRadioGroup
        className={classes.radioGroup}
        name={name}
        onChange={handleChange}
        value={value}
      >
        <List items={optionsMapped} />
      </MuiRadioGroup>
    </FormControl>
  );
};
